import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type EventqScrollAreaAxis = 'vertical' | 'horizontal' | 'both';

/** Host background the scrollbar sits on — drives contrast from existing palette tokens. */
export type EventqScrollAreaSurface = 'midnight' | 'deep' | 'hub' | 'dark-forms';

@Component({
  selector: 'eventq-scroll-area',
  templateUrl: './scroll-area.html',
  styleUrl: './scroll-area.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.eventq-scroll-area--vertical]': 'axis() === "vertical"',
    '[class.eventq-scroll-area--horizontal]': 'axis() === "horizontal"',
    '[class.eventq-scroll-area--both]': 'axis() === "both"',
    '[class.eventq-scroll-area--fill]': 'fill()',
    '[class.eventq-scroll-area--surface-midnight]': 'surface() === "midnight"',
    '[class.eventq-scroll-area--surface-deep]': 'surface() === "deep"',
    '[class.eventq-scroll-area--surface-hub]': 'surface() === "hub"',
    '[class.eventq-scroll-area--surface-dark-forms]': 'surface() === "dark-forms"',
  },
})
export class EventqScrollArea {
  readonly axis = input<EventqScrollAreaAxis>('vertical');
  readonly fill = input(false);
  readonly surface = input<EventqScrollAreaSurface>('deep');
}
